export default "__VITE_ASSET__ly7626hR__"